module.exports = __webpack_public_path__ + "static/img/10.1fb7754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cultours/tour3/10.jpg
// module id = O2fm
// module chunks = 0